/**
 * @generated SignedSource<<281af4a044d13a7462a5b4df427651df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Sidebar_businessaccount$data = {
  readonly branding: {
    readonly shopName: string | null;
    readonly logoUrl: string | null;
  } | null;
  readonly " $fragmentType": "Sidebar_businessaccount";
};
export type Sidebar_businessaccount$key = {
  readonly " $data"?: Sidebar_businessaccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"Sidebar_businessaccount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Sidebar_businessaccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BusinessAccountBranding",
      "kind": "LinkedField",
      "name": "branding",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shopName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logoUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BusinessAccount",
  "abstractKey": null
};

(node as any).hash = "e4e25e4d52ff2e0221f1eb06afb940b1";

export default node;
